import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import IconFacebook from 'components/icons/IconFacebook';
import IconLinkedin from 'components/icons/IconLinkedin';
import IconTwitter from 'components/icons/IconTwitter';
import IconInstagram from 'components/icons/IconInstagram';
import IconYoutube from 'components/icons/IconYoutube';

const styles = theme => ({
  root: {
    height: '64px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'none',
    zIndex: 1200,
    background: theme.palette.secondary['800'],
  },
  socialMedia: {
    marginLeft: 25,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 15,
    },
  },
  typographyCopyright: {
    marginRight: 25,
    color: theme.palette.grey[600],
    [theme.breakpoints.down('xs')]: {
      marginRight: 15,
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: 1190,
    margin: '0 auto',
  },
  icon: {
    width: 20,
    height: 20,
  },
  iconInstagram: {
    width: 24,
    height: 24,
    position: 'relative',
    top: 2,
  },
  iconYoutube: {
    width: 24,
    height: 24,
    position: 'relative',
    top: 2,
  },
});

const LandingFooter = ({ classes }) => (
  <footer className={classes.root}>
    <div className={classes.content}>
      <div className={classes.socialMedia}>
        <IconButton href="https://www.facebook.com/dme4dme" target="_blank">
          <IconFacebook className={classes.icon} />
        </IconButton>
        <IconButton href="https://www.twitter.com/dme4dme" target="_blank">
          <IconTwitter className={classes.icon} />
        </IconButton>
        <IconButton href="https://www.linkedin.com/company/dme4dme" target="_blank">
          <IconLinkedin className={classes.icon} />
        </IconButton>
        <IconButton href="https://www.instagram.com/dme4dme" target="_blank">
          <IconInstagram className={classes.iconInstagram} />
        </IconButton>
        <IconButton href="https://www.youtube.com/channel/UCQdlHTMhVGac-CIczNhYB3Q" target="_blank">
          <IconYoutube className={classes.iconYoutube} />
        </IconButton>
      </div>
      <Typography className={classes.typographyCopyright}>
        DME for DME © All rights reserved
      </Typography>
    </div>
  </footer>
);

LandingFooter.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    socialMedia: PropTypes.string.isRequired,
    typographyCopyright: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(LandingFooter);



// WEBPACK FOOTER //
// ./src/components/common/Layout/LandingFooter/LandingFooter.js